import VerifyPanel from '../Verify/VerifyPanel';
import type { VerifyPanelProps } from '../Verify/VerifyPanel';

type VerifyStepProps = Pick<VerifyPanelProps, 'verification' | 'phone' | 'email' | 'onPhoneChange' | 'onEmailChange' | 'notice'> & {
  title?: string;
  intro?: string;
};

// Verify-first gate: a heading and an intro around the shared VerifyPanel (Verify/), which is the channel toggle, the input for it and
// the code prompt. The panel's rcv-* styles come with it, the same as in Step1Welcome's returning-customer block.
function VerifyStep({ title = 'Order Parts Online', intro = "Verify your phone or email to see your pricing and start an order. We'll send you a one-time code.", ...panel }: VerifyStepProps) {
  return (
    <div className="form-step">
      <h2>{title}</h2>
      <p className="step-intro">{intro}</p>
      <VerifyPanel {...panel} heading="Let's confirm it's you" subheading="Choose text or email, then enter where we should send the code." />
    </div>
  );
}

export default VerifyStep;
